import EstimatePopulationContent from './EstimatePopulationContent'
import EstimatePopulationController from './EstimatePopulationController'

export { default } from './EstimatePopulation'

export const EstimatePopulationMapConfig = {
  Content: EstimatePopulationContent,
  Controller: EstimatePopulationController,
}
